import React from 'react'
import {Icon} from '@chakra-ui/react'

const WarningIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" data-testid="warning-icon" cursor="pointer" {...props}>
            <path
                fillRule="evenodd"
                fill="currentColor"
                clipRule="evenodd"
                d="M10.4599 1.08841C11.1444 
            -0.0971778 12.8556 -0.0971772 13.5401 1.08841L23.7591 18.7882C24.4436 19.9738 23.588 21.4557 22.219 
            21.4557H1.78103C0.412035 21.4557 -0.443587 19.9738 0.240911 18.7882L10.4599 1.08841ZM12.6112 1.6247C12.3396 
            1.15416 11.6604 1.15416 11.3888 1.6247L1.16979 19.3245C0.898127 19.795 1.23771 20.3832 1.78103 20.3832H22.219C22.7623 
            20.3832 23.1019 19.795 22.8302 19.3245L12.6112 1.6247ZM12.0003 7.0307C12.2964 7.0307 12.5365 7.27081 12.5365 7.56699V13.6079C12.5365 
            13.9041 12.2964 14.1442 12.0003 14.1442C11.7041 14.1442 11.464 13.9041 11.464 13.6079V7.56699C11.464 7.27081 11.7041 7.0307 12.0003 
            7.0307ZM12.0003 15.6817C12.2964 15.6817 12.5365 15.9218 12.5365 16.2179V16.2616C12.5365 16.5578 12.2964 16.7979 12.0003 16.7979C11.7041 
            16.7979 11.464 16.5578 11.464 16.2616V16.2179C11.464 15.9218 11.7041 15.6817 12.0003 15.6817Z"
            />
        </Icon>
    )
}

export default WarningIcon
